import React from "react";
import {
	FileSpreadsheet,
	Download,
	ReceiptText,
	Files
} from "lucide-react";

import API_BASE_URL from "../../apiconfig";

function DownloadData() {

	const showAlert = (message) => {
		alert(message);
	};

	const handleDownload = async (type, fileName) => {

		try {

			const token = sessionStorage.getItem("adminToken");

			const response = await fetch(
				`${API_BASE_URL}/API/Admin/${type}`,
				{
					method: "GET",
					headers: {
						"Authorization": "Bearer " + token
					}
				}
			);

			if (response.ok) {

				const blob = await response.blob();

				const url = window.URL.createObjectURL(blob);

				const a = document.createElement("a");

				a.href = url;

				a.download = fileName;

				document.body.appendChild(a);

				a.click();

				a.remove();

				window.URL.revokeObjectURL(url);

				showAlert("File Downloaded Successfully ✅");

			} else {

				showAlert("Failed to download file ❌");

			}

		} catch (error) {

			console.error(error);

			showAlert("Server Error ❌");

		}
	};

	return (
		<>
			<style>
				{`
					.download-page{
						padding:20px;
					}

					.download-header{
						margin-bottom:24px;
					}

					.download-header h2{
						margin:0;
						font-size:28px;
						font-weight:700;
						color:#0f172a;
					}

					.download-header p{
						margin-top:6px;
						color:#64748b;
						font-size:14px;
					}

					.download-grid{
						display:grid;
						grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
						gap:22px;
					}

					.download-card{
						background:#ffffff;
						border-radius:18px;
						padding:24px;
						border:1px solid #e2e8f0;

						box-shadow:
							0 4px 12px rgba(15,23,42,0.05);

						transition:0.3s ease;
					}

					.download-card:hover{
						transform:translateY(-4px);

						box-shadow:
							0 12px 24px rgba(15,23,42,0.08);
					}

					.card-icon{
						width:60px;
						height:60px;

						border-radius:14px;

						display:flex;
						align-items:center;
						justify-content:center;

						margin-bottom:18px;

						background:linear-gradient(
							135deg,
							#2563eb,
							#1d4ed8
						);

						color:white;
					}

					.card-title{
						font-size:18px;
						font-weight:700;
						color:#0f172a;

						margin-bottom:8px;
					}

					.card-desc{
						font-size:14px;
						line-height:1.5;
						color:#64748b;

						margin-bottom:22px;
					}

					.download-btn{
						width:100%;

						border:none;
						outline:none;

						padding:13px 18px;

						border-radius:12px;

						background:linear-gradient(
							135deg,
							#2563eb,
							#1e40af
						);

						color:white;

						font-size:14px;
						font-weight:600;

						display:flex;
						align-items:center;
						justify-content:center;
						gap:8px;

						cursor:pointer;

						transition:0.3s ease;
					}

					.download-btn:hover{
						transform:scale(1.02);
					}

					@media(max-width:768px){

						.download-header h2{
							font-size:22px;
						}

						.download-page{
							padding:10px;
						}
					}
				`}
			</style>

			<div className="download-page">

				<div className="download-header">
					<h2>Download Reports</h2>

					<p>
						Download application and payment reports in Excel format.
					</p>
				</div>

				<div className="download-grid">

					{/* All Applications */}
					<div className="download-card">

						<div className="card-icon">
							<Files size={28} />
						</div>

						<div className="card-title">
							Registration
						</div>

						<div className="card-desc">
							Download complete Registration data of students.
						</div>

						<button
							className="download-btn"
							onClick={() =>
								handleDownload(
									"DOWNLOAD_ALL_REGISTRATION",
									"REGISTRATION_ASTU_JLEE_JMEE.xlsx"
								)
							}
						>
							<Download size={18} />
							Download Registration Data
						</button>

					</div>

					{/* Paid Applications */}
					<div className="download-card">

						<div className="card-icon">
							<FileSpreadsheet size={28} />
						</div>

						<div className="card-title">
							Webmaster
						</div>

						<div className="card-desc">
							Download student application records Webmaster.
						</div>

						<button
							className="download-btn"
							onClick={() =>
								handleDownload(
									"DOWNLOAD_WEBMASTER",
									"WEBMASTER_ASTU_JMEE_JLEE.xlsx"
								)
							}
						>
							<Download size={18} />
							Download Excel
						</button>

					</div>

					{/* Payment Report */}
					<div className="download-card">

						<div className="card-icon">
							<ReceiptText size={28} />
						</div>

						<div className="card-title">
							Payment Report
						</div>

						<div className="card-desc">
							Download detailed payment transaction and report information.
						</div>

						<button
							className="download-btn"
							onClick={() =>
								handleDownload(
									"DOWNLOAD_PAYMENT",
									"PAYMENT_ASTU_JMEE_JLEE.xlsx"
								)
							}
						>
							<Download size={18} />
							Download Excel
						</button>

					</div>

				</div>

			</div>
		</>
	);
}

export default DownloadData;